$(document).ready(() => {
	var viewportWidth = $(window).width();

	var headerHeight = $("#header").height();
	var headerTopHeight = $("#header .header-top .container-fluid").height();
	var headerBottomHeight = $("#header .header-top .container-full").height();
	var headerHeightScroll = headerHeight - headerBottomHeight;

	$("#wrapper").css("padding-top",headerHeight);		

	// DETECT SCROLL FOR HEADER
	$(window).scroll(function() {
		/* HEADER SCROLL */

		if ($(window).scrollTop() > headerHeight) {
			$("#header").addClass("scrolling");
		} else {
			$("#header").removeClass("scrolling");
		}
	});

	// /* BACK TO TOP */
	var btnAnchor = $('.scroll-top');

	$(window).scroll(function() {
	  if ($(window).scrollTop() > 350) {
	    btnAnchor.addClass('show');
	  } else {
	    btnAnchor.removeClass('show');
	  }
	});
    
	btnAnchor.on('click', function(e) {
	  e.preventDefault();
	  $('html, body').animate({scrollTop:0}, '300');
	});


	// header height to display search modal underneath
	$('.search__offcanvas').css('top',headerHeight);


    $('.page-content table').each(function() {
        $(this).wrap('<div class="table-responsive"></div>');
    });


	// Read more function */
	$( ".read_more_toggle" ).click(function() {
		$(".read_more_content").toggleClass( "open" );
	});


    // IFRAME VIDEOS RATIO IF NOT CREATIVE ELEMENT
    $('.page-cms .page-content iframe').each(function() {
	    if (!$(this).parent().hasClass('elementor-custom-embed')) {
	        var wrapper = $('<div class="ratio ratio-16x9"></div>');
	        $(this).wrap(wrapper);
	    }
	});


	// GET CMS SIZE GUIDE CONTENT AS MODAL
	if ($('.page-product').length) {
	    $(document).on('click', 'button[data-bs-target="#size-guide-modal"]', function () {
	        if ($('.size-guide-content').length) {
	        	var sizeGuideContent = $('.size-guide-content').html(); // Get the size guide content
	        	$('#size-guide-modal .modal-body').html(sizeGuideContent); // Insert it into the modal body
	        			
	            $("#cms-modal .modal-body table").each(function() {// Wrap tables inside the modal with .table-responsive div
	                $(this).wrap("<div class='table-responsive'></div>");
	            });
	        }

        });
	}


	// Wait until the modal content is loaded
	$(document).on('shown.bs.modal', '#blockcart-modal', function () {
	  // Ensure there are slides before initializing
	  if ($('.swiper-crossselling .swiper-slide').length) {
	    var swiper = new Swiper(".swiper-crossselling", {
	      slidesPerView: 2,
	      slidesPerGroup: 1,
	      watchOverflow: true,
	      breakpoints: {
	        576: {
	          slidesPerView: 2,
	          slidesPerGroup: 1,
	        },
	        768: {
	          slidesPerView: 3,
	          slidesPerGroup: 1,
	        },
	        992: {
	          slidesPerView: 3,
	          slidesPerGroup: 1,
	        },
	        1200: {
	          slidesPerView: 3,
	          slidesPerGroup: 1,
	        }
	      },
	      navigation: {
	        nextEl: '.swiper-crossselling-button-next',
	        prevEl: '.swiper-crossselling-button-prev',
	      },
	    });
	  }
	});

 


});
